const ca = {
  pleaseEnterUsername: "Si us plau, introdueix un nom d'usuari",
  cannotFriendYourself: "No pots enviar una sol·licitud d'amistat a tu mateix.",
  friendRequestSent: "Sol·licitud d'amistat enviada!",
  failedToSendRequest: "No s'ha pogut enviar la sol·licitud",
  linkCopied: "Enllaç copiat al porta-retalls!",
  backToInvites: "Torna a les invitacions",
  sendFriendRequestByUsername: "Enviar una sol·licitud d'amistat per nom d'usuari",
  enterUsername: "Introdueix un nom d'usuari",
  send: "Enviar",
  yourInviteQrCode: "El teu codi QR d'invitació",
  inviteLink: "Enllaç d'invitació",
  scanQrOrUseLink: "Escaneja aquest codi QR o utilitza aquest enllaç per enviar una sol·licitud d'amistat",
  copyInviteLink: "Copiar l'enllaç d'invitació",
  goToItem: "Anar a l'element",
  verificationEmailSent: "Correu de verificació enviat! Revisa la teva safata d'entrada.",
  verificationEmailFailed: "No s'ha pogut enviar el correu de verificació. Torna-ho a provar.",
  verifyYourEmail: "Verifica el teu correu electrònic",
  verifyEmailInstructions: "Verifica la teva adreça de correu electrònic per accedir al teu compte. Revisa la safata d'entrada per trobar l'enllaç de verificació.",
  sending: "Enviant...",
  resendVerificationEmail: "Tornar a enviar el correu de verificació",
  login: "Iniciar sessió",
  register: "Registrar-se",
  home: "Inici",
  calendar: "Calendari",
  friends: "Amics",
  profile: "Perfil",
  logout: "Tancar sessió",
  loading: "Carregant...",
  language: "Idioma",
  calendarSelectPlaceSuggestion: "Selecciona un lloc dels suggeriments perquè s'hi adjuntin les coordenades.",
  calendarSelectDateAndTime: "Selecciona una data i una hora.",
  calendarPositiveDuration: "Introdueix una durada positiva.",
  calendarFutureDateRequired: "La data i l'hora de l'esdeveniment han de ser futures.",
  calendarCreateEventFailed: "No s'ha pogut crear l'esdeveniment. Torna-ho a provar.",
  cancel: "Cancel·lar",
  createNewEvent: "Crear un nou esdeveniment",
  week: "Setmana",
  month: "Mes",
  eventTitle: "Títol",
  date: "Data",
  time: "Hora",
  duration: "Durada",
  endsAt: "Finalitza a les",
  place: "Lloc",
  searchForPlace: "Cercar un lloc",
  placeSearchTip: "Consell: comença a escriure i selecciona un resultat per adjuntar-hi coordenades.",
  description: "Descripció",
  createEvent: "Crear esdeveniment",
  today: "Avui",
  previousMonth: "Mes anterior",
  nextMonth: "Mes següent",
  previous: "Anterior",
  next: "Següent",
  mondayShort: "Dl",
  tuesdayShort: "Dt",
  wednesdayShort: "Dc",
  thursdayShort: "Dj",
  fridayShort: "Dv",
  saturdayShort: "Ds",
  sundayShort: "Dg",
  more: "més",
  mustRespondWillBeforeReposting: 'Has de respondre "Hi assistiré" abans de tornar a publicar',
  event: "Esdeveniment",
  backToCalendar: "Tornar al calendari",
  addToGoogleCalendar: "Afegir a Google Calendar",
  when: "Quan",
  where: "On",
  openLocationInGoogleMaps: "Obrir la ubicació a Google Maps",
  hosts: "Organitzadors",
  yourResponse: "La teva resposta",
  currentResponse: "Resposta actual",
  response_will: "Hi assistiré",
  response_might: "Potser hi assistiré",
  response_wont: "No hi assistiré",
  willRunIntoYou: "Hi passaré",
  mightDropBy: "Potser hi passaré",
  wontCome: "No hi aniré",
  repostToMyFriends: "Tornar a publicar als meus amics",
  responses: "Respostes",
  willAttend: "Hi assistiré",
  reposted: "Republicat",
  mightAttend: "Potser hi assistiré",
  cancelEvent: "Cancel·lar l'esdeveniment",
  cancellationEmailNoticeBefore: "Les persones que han indicat que assistiran",
  cancellationEmailNoticeAfter: "rebran un correu electrònic per notificar-los la cancel·lació.",
  optionalCancellationMessage: "Missatge opcional per als assistents (màxim 1000 caràcters)",
  confirmCancelEvent: "Confirmar la cancel·lació de l'esdeveniment",
  clear: "Esborrar",
  confirmCancellation: "Confirmar la cancel·lació",
  confirmCancellationMessage: "Segur que vols cancel·lar aquest esdeveniment? Això notificarà els assistents confirmats i eliminarà l'esdeveniment.",
  eventCancelledNotified: "Esdeveniment cancel·lat. S'ha notificat a",
  attendees: "assistents",
  failedToCancelEvent: "No s'ha pogut cancel·lar l'esdeveniment",
  back: "Tornar",
  cancelled: "Cancel·lat",
  ok: "D'acord",
  forgotPassword: "He oblidat la contrasenya",
  email: "Correu electrònic",
  passwordResetLinkSent: "Si el compte existeix, s'ha enviat un enllaç de restabliment.",
  passwordResetRequestFailed: "No s'ha pogut sol·licitar el restabliment de la contrasenya.",
  sendResetLink: "Enviar l'enllaç de restabliment",
  addFriend: "Afegir amic",
  incomingRequests: "Sol·licituds rebudes",
  accept: "Acceptar",
  deny: "Rebutjar",
  myFriends: "Els meus amics",
  noFriendsYet: "Encara no tens amics. Comença a afegir-ne!",
  seeProfile: "Veure perfil",
  noEventsToRespondTo: "No hi ha esdeveniments per respondre",
  allCaughtUp: "Ja estàs al dia. Torna més tard per veure nous esdeveniments dels teus amics.",
  events: "Esdeveniments",
  unknown: "Desconegut",
  noDescriptionProvided: "No s'ha proporcionat cap descripció.",
  will: "Sí",
  maybe: "Potser",
  wont: "No",
  userNotFound: "Usuari no trobat",
  friendRequestSentSuccessfully: "Sol·licitud d'amistat enviada correctament!",
  friendInvitation: "Invitació d'amistat",
  sendFriendRequest: "Enviar sol·licitud d'amistat",
  loginToSendFriendRequest: "Inicia la sessió per enviar una sol·licitud d'amistat",
  chooseLanguage: "Escull l'idioma",
  invalidCredentials: "Credencials no vàlides. Torna-ho a provar.",
  username: "Nom d'usuari",
  password: "Contrasenya",
  forgotPasswordQuestion: "Has oblidat la contrasenya?",
  dontHaveAccount: "No tens un compte?",
  registerHere: "Registra't aquí",
  invalidProfilePhotoType: "Tipus de fitxer no vàlid. Penja una imatge JPEG, PNG, GIF o WebP.",
  invalidFileExtension: "Extensió de fitxer no vàlida",
  allowedExtensions: "Permeses",
  fileTooLarge: "El fitxer és massa gran",
  maximumFileSize: "Màxim",
  profilePhotoRemoved: "La foto de perfil s'ha eliminat.",
  failedToRemoveProfilePhoto: "No s'ha pogut eliminar la foto de perfil",
  profileUpdatedSuccessfully: "Perfil actualitzat correctament!",
  failedToUpdateProfile: "No s'ha pogut actualitzar el perfil",
  privateEmailExplanation: "Només tu pots veure el teu correu electrònic per evitar missatges no sol·licitats fora de la plataforma",
  yourEmailIsPrivate: "El teu correu electrònic és privat.",
  profilePhoto: "Foto de perfil",
  removePhoto: "Eliminar foto",
  firstName: "Nom",
  lastName: "Cognom",
  tellPeopleAboutYourself: "Parla'ns de tu",
  whereToContactMe: "Com contactar amb mi",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Desar",
  notSet: "No definit",
  editProfile: "Editar perfil",
  imageToCrop: "Imatge per retallar",
  zoom: "Zoom",
  usePhoto: "Utilitzar la foto",
  name: "Nom",
  whereToContact: "Contacte",
  removeFriendship: "Eliminar amistat",
  confirmRemoveFriend: "Confirmar eliminació de l'amic",
  confirmRemoveFriendBefore: "Segur que vols eliminar",
  confirmRemoveFriendAfter: "de la teva llista d'amics?",
  friendRemoved: "Amic eliminat.",
  failedToRemoveFriend: "No s'ha pogut eliminar l'amic.",
  confirmRemove: "Confirmar eliminació",
  error: "Error",
  removed: "Eliminat",
  passwordsDoNotMatch: "Les contrasenyes no coincideixen",
  registrationFailed: "El registre ha fallat. Torna-ho a provar.",
  confirmPassword: "Confirmar contrasenya",
  alreadyHaveAccount: "Ja tens un compte?",
  loginHere: "Inicia sessió aquí",
  passwordResetSuccessfully: "Contrasenya restablerta correctament.",
  failedToResetPassword: "No s'ha pogut restablir la contrasenya.",
  resetPassword: "Restablir contrasenya",
  newPassword: "Nova contrasenya",
  confirmNewPassword: "Confirmar nova contrasenya",
  setNewPassword: "Establir nova contrasenya",
  emailVerifiedSuccessfully: "Correu electrònic verificat correctament!",
  emailVerificationFailed: "La verificació ha fallat. L'enllaç podria ser invàlid o haver caducat.",
  verifying: "Verificant...",
  verified: "Verificat!",
  redirectingToHome: "Redirigint a l'inici...",
  verificationFailed: "La verificació ha fallat",
  goToHome: "Anar a l'inici",
  about: "Quant a",
  aboutConceptTitle: "Concepte",
  aboutCreatorIntroduction: "Hola, soc Crypt0, escalador i creador de Run Into Me.",
  aboutCreatorStory: "Vaig crear aquest lloc perquè soc molt sociable i dedicava massa temps a organitzar sessions amb altres escaladors.",
  aboutPlanningProblem: "Volia avisar tothom alhora de quan i on escalaria, sense invitacions formals.",
  aboutDeveloperSolution: "Aleshores vaig recordar que soc desenvolupador i podia crear jo mateix una solució.",
  aboutWelcome: "Benvingut a Run Into Me, un lloc per anunciar activitats a les quals els teus amics es poden afegir sense pressió.",
  aboutCallToAction: "Publica aquí la pròxima activitat que sigui més divertida en companyia!",
  aboutTutorialTitle: "Tutorial",
  aboutCalendarCreateEvent: "La pantalla Calendari també permet crear un esdeveniment.",
  aboutEventColorsIntroduction: "Els colors indiquen la participació:",
  aboutColorGold: "Daurat",
  aboutColorGoldDescription: "Organitzes aquest esdeveniment.",
  aboutColorGreen: "Verd",
  aboutColorGreenDescription: "Hi assistiràs.",
  aboutColorOrange: "Taronja",
  aboutColorOrangeDescription: "Has respost «potser».",
  aboutColorBlue: "Blau",
  aboutColorBlueDescription: "Encara no has respost.",
  aboutColorGray: "Gris",
  aboutColorGrayDescription: "Has rebutjat la invitació.",
  aboutCalendarEventDetails: "Fes clic en un esdeveniment per veure’n els detalls i respondre.",
  aboutFriendPageTitle: "Pàgina d’amics",
  aboutFriendPageDescription: "Introdueix el nom d’usuari o envia l’enllaç d’invitació / codi QR.",
  aboutHomePageTitle: "Pàgina d’inici",
  aboutHomePageDescription: "Consulta els esdeveniments i indica si hi assistiràs.",
  aboutRepostScreenTitle: "Pantalla de republicació",
  aboutGoogleCalendarDescription: "Afegeix l’esdeveniment a Google Calendar amb aquest botó.",
  aboutRepostDescription: "Després de confirmar l’assistència, pots republicar-lo als teus amics.",
};

export default ca;